import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from '../_services/session/session.service';

@Injectable({
  providedIn: 'root',
})
export class SiteAppointmentsReadGuard {
  constructor(
    private session: SessionService,
    private router: Router,
  ) {}

  private readonly routePermissionMap: Record<string, string[]> = {
    appointments: [
      'APPOINTMENTS.READ',
      'APPOINTMENTS.CREATE',
      'APPOINTMENTS.UPDATE',
      'APPOINTMENTS.DELETE',
    ],
    patients: [
      'PATIENTS.READ',
      'PATIENTS.CREATE',
      'PATIENTS.UPDATE',
      'PATIENTS.DELETE',
    ],
    sales: ['SALES.READ', 'SALES.CREATE', 'SALES.UPDATE', 'SALES.DELETE'],
    statistics: ['STATISTICS.READ'],
    dashboard: ['DASHBOARD.READ', 'STATISTICS.READ'],
    incidents: ['INCIDENTS.READ'],
  };

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const customerIdentifier = route.params['customer'];
    const siteIdentifier = route.params['site'];
    const modulePath = state.url.split('?')[0].split('/').filter(Boolean)[2];
    const requiredPermissions = this.routePermissionMap[modulePath] || [];

    const permissions = this.session.getPermissions() || [];
    const customer = permissions.find(
      (item) =>
        String(item.identifier) === String(customerIdentifier) ||
        String(item.id) === String(customerIdentifier),
    );

    if (!customer) {
      return this.router.createUrlTree(['']);
    }

    if (this.session.isSuperUser() || this.session.isCustomerAdmin(customer)) {
      return true;
    }

    const site = (customer.sites || []).find(
      (item) =>
        String(item.identifier) === String(siteIdentifier) ||
        String(item.id) === String(siteIdentifier),
    );

    if (!site) {
      return this.router.createUrlTree(['']);
    }

    if (!requiredPermissions.length) {
      return true;
    }

    const hasPermission = requiredPermissions.some((requiredPermission) =>
      this.session.hasPermission(customer, site, requiredPermission),
    );

    return hasPermission ? true : this.router.createUrlTree(['']);
  }
}
